import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
  Device,
  DevicesService,
  DialogService,
  IDeviceData,
  LmapService,
  NotificationService,
  TestAssembleService,
  TestListService,
  TestServerConfigService,
  TimeoutWrapperService
} from '@nrwl/common-lib';
import { ControllerApiService } from '@nrwl/test-setup';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'nrwl-twamp-reflector',
  templateUrl: './twamp-reflector.component.html',
  styleUrls: ['./twamp-reflector.component.scss']
})
export class TwampReflectorComponent implements OnInit, OnDestroy {
  @ViewChild('reflectorForm', { static: true }) form: NgForm;

  deviceData: IDeviceData;
  deviceName: string;
  activity: any;
  agentModel: string;
  raiseConfirm = false;
  monitorStarted = false;
  holdingPattern = false; //true when waiting for confirmation test really got started without any errors
  actionMsg = null;
  errorMsg = null;
  errorIcon = 'warning';
  testNameisValid = true;
  isLoading = false;
  mgmtPortTesting = false;
  viewTestObj: any = {};
  newTestObj: any = {};
  formObj: any = {};
  isAllowPersist = false;
  liteModeSelect = false;
  ipVersionEnabled = true;
  isNewTestConfig = false;
  isnotUniqueConfig = false;
  selectedIpVersion = 'v4';
  activeTabID = null;
  allActiveTestList = [];
  activeTestlist = [];
  savedTestConfigs = [];
  removeConfirm = false;
  testConfigs = [];
  maxConcurrentTestCount = 0;
  isExceedMaxTest = false;
  isnotUniqueIPConfig = false;
  selctedTestID = null;
  selectedTestInfo = null;
  reflectorModeName = null;
  schedName: string;
  activeSessions = '---';
  activeFlows = '---';
  packetsReflected = '---';
  sessionsConfig = {
    maxFlows: '5',
    maxSessions: '5'
  };
  flowsConfig = {
    maxFlows: '50'
  };
  defaultConfig = {
    instanceName: null,
    ipAddress: '192.168.2.10',
    subnet: '255.255.255.0',
    gateway: '192.168.2.1',
    ipAddressV6: 'fc00::10',
    prefixV6: '64',
    gatewayV6: 'fc00::1',
    ipVersion: 'v4',
    port: '862',
    maxSessions: '5',
    udpport: '50000',
    maxFlows: '50',
    reflectorMode: 'full',
    liteModeSelect: false,
    vlanNumber: 'untagged',
    etherType: '88a8'
  };

  controlPortPattern =
    /^([1-9]|[1-9]\d{1,3}|[1-5]\d{4}|6[0-4]\d{3}|65[0-4]\d{2}|655[0-2]\d|6553[0-5])$/;
  vLanPattern = /^([1-9]|[1-9]\d{1,2}|[1-3]\d{3}|40[0-8]\d|409[0-5])$/;
  vLanPriorityPattern = /^([0-7]?)$/;
  vLanPriority = '0';
  ipv6PrefixLengthPattern = /^([1-9][0-9]?|1[01][0-9]|12[0-8])$/;
  ipv4SubnetPattern =
    /^(((255\.){3}(255|254|252|248|240|224|192|128|0+))|((255\.){2}(255|254|252|248|240|224|192|128|0+)\.0)|((255\.)(255|254|252|248|240|224|192|128|0+)(\.0+){2})|((255|254|252|248|240|224|192|128|0+)(\.0+){3}))$/;
  ipv4Pattern =
    /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
  ipv6Pattern =
    /^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$/;
  private readonly unsubscribe: Subject<void> = new Subject();
  private timeoutPromise = {};
  private pollingInterval = 4000;
  constructor(
    private readonly controllerApiService: ControllerApiService,
    private readonly lmap: LmapService,
    private readonly timeout: TimeoutWrapperService,
    private readonly testListService: TestListService,
    private readonly serverConfigService: TestServerConfigService,
    private readonly testAssembleService: TestAssembleService,
    private readonly notificationService: NotificationService,
    private readonly dialogService: DialogService,
    private readonly deviceService: DevicesService,
    @Inject(MAT_DIALOG_DATA) public data: Device
  ) {}

  ngOnInit(): void {
    this.deviceData = this.data.deviceData;
    this.deviceName = this.deviceData.nameId;
    this.agentModel = this.data.getModel();
    this.schedName = 'TWAMP-REFLECTOR-' + this.data.getUniqueName();
    this.activity = this.deviceData.phyId
      ? this.deviceData.activity[this.deviceData.phyId]
      : this.deviceData.activity;
    this.getDeviceCapabilities();
    this.newTestObj = { ...this.defaultConfig };
    this.activeTestlist = this.getActiveTestlist();
    // if we are running then start polling for status
    if (
      (this.activity?.status === 'running' && this.activity?.tests['twamp-light-reflector']) ||
      this.activity?.tests['twamp-reflector']
    ) {
      this.reflectorModeName = this.selectedTestInfo.type
        ? this.selectedTestInfo.type
        : this.activeTestlist[0].type;
      this.getActiveTestConfigs(this.selctedTestID);
    } else {
      this.isNewTestConfig = true;
      this.getInactiveTestConfigs('newTest');
    }
    this.getSavedTestConfigs();
    this.testConfigs = [];
    this.getRunningTestConfigs();
  }

  ngOnDestroy(): void {
    if (this.timeoutPromise) {
      Object.keys(this.timeoutPromise).forEach((key, index) => {
        this.timeout.cancel(key);
      });
    }
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
  getDeviceCapabilities(): void {
    //Enable IpV6 based on capability
    if (this.deviceData) {
      //Ipv6 control
      let cap;
      if (this.deviceData.capabilities.diagnostics) {
        const index = this.agentModel.indexOf('vPMA');
        if (this.deviceData.capabilities.diagnostics['reboot-allowed'] === 'true' && index != -1) {
          this.isAllowPersist = true;
        } else {
          this.isAllowPersist = false;
        }
      }
      const testPortPhyId = this.deviceData['phyId'];
      if (testPortPhyId) {
        //For QT
        const selList = this.liteModeSelect ? 'twamp-light-reflector-list' : 'twamp-reflector-list';
        const capList = this.deviceData.capabilities[selList];
        for (const key in capList) {
          if (testPortPhyId === capList[key]['phy-id']) {
            cap = capList[key];
            break;
          }
        }
      } else {
        //vPMA
        cap = this.deviceData.capabilities['twamp-reflector'];
        // if (this.liteModeSelect) {
        //     cap = this.ep.extension.capabilities['twamp-light-reflector'];
        // }
      }

      if (cap) {
        if (this.agentModel === 'QT600-10') {
          this.ipVersionEnabled = true;

          // MV-2567 if QT600-10 then max flows and sessions are not configurable. Show what is set in
          // capabilities and disable the field
          this.defaultConfig.maxSessions =
            cap['max-control-sessions-per-test'] || this.defaultConfig.maxSessions;
          this.defaultConfig.maxFlows = cap['max-flows-per-test'] || this.defaultConfig.maxFlows;
        } else {
          this.ipVersionEnabled = 'true' === cap.ipv6;
        }
        this.maxConcurrentTestCount = cap['max-concurrent-tests'];
        this.flowsConfig.maxFlows = cap['max-flows-per-test'];
        this.sessionsConfig.maxSessions = cap['max-control-sessions-per-test'];
      }
    }

    if (
      this.agentModel.indexOf('vPMA') >= 0 &&
      this.deviceData.capabilities.system['management-port-testing'] === 'true' &&
      this.deviceData.mgmtIPaddress
    ) {
      this.mgmtPortTesting = true;
      if (this.ipv4Pattern.test(this.deviceData.mgmtIPaddress)) {
        this.newTestObj.ipVersion = 'v4';
        this.newTestObj.ipAddress = this.deviceData.mgmtIPaddress;
      } else {
        this.newTestObj.ipVersion = 'v6';
        this.newTestObj.ipAddressV6 = this.deviceData.mgmtIPaddress;
      }
    }
  }

  getActiveTestConfigs(testId: number): void {
    this.activeSessions = '---';
    this.activeFlows = '---';
    this.packetsReflected = '---';
    // Check reflector mode: Standard or Lite mode
    if (this.reflectorModeName === 'twamp-reflector') {
      this.viewTestObj.reflectorMode = 'full';
      this.viewTestObj.liteModeSelect = false;
    } else if (this.reflectorModeName === 'twamp-light-reflector') {
      this.viewTestObj.liteModeSelect = true;
      this.viewTestObj.reflectorMode = 'light';
    }
    // get our config from the controller because this config is exactly what started the reflector.
    this.controllerApiService
      .getTestConfig(testId, true)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(response => {
        if (response.status === 'success') {
          this.updateInstanceName(testId, response);
          const config = this.lmap.getTestOptions(
            this.reflectorModeName,
            [
              'source-ip',
              'subnet',
              'prefix-length',
              'gateway',
              'reflector-udp-port',
              'max-connections',
              'max-flows',
              'twamp',
              'vlan-id',
              'vlan-priority',
              'inner-vlan-id',
              'inner-vlan-priority',
              'tpid',
              'persist'
            ],
            response.data.config
          );
          this.viewTestObj.ipAddress = config['source-ip'];
          this.viewTestObj.subnet = config.subnet;
          this.viewTestObj.gateway = config.gateway;
          if (this.agentModel.indexOf('vPMA') != -1) {
            this.viewTestObj.vlanId = '';
            this.viewTestObj.sVlanId = config['vlan-id'] || '';
            this.viewTestObj.cVlan = config['inner-vlan-id'] || '';
            this.viewTestObj.cVlanPriority = config['inner-vlan-priority'] || 0;
          } else {
            this.viewTestObj.vlanId = config['vlan-id'] || '';
          }
          this.viewTestObj.vLanPriority = config['vlan-priority'] || '0';
          this.viewTestObj.enableVlan = !!this.viewTestObj.vlanId;
          let configVlan = 'untagged';
          if (this.viewTestObj.sVlanId && this.viewTestObj.cVlan) {
            configVlan = 'q_in_q';
          } else if (this.viewTestObj.sVlanId) {
            configVlan = 'tagged';
          }
          this.viewTestObj.etherType = config['tpid'] || this.defaultConfig.etherType;
          this.viewTestObj.vlanNumber = configVlan;
          this.viewTestObj.instanceName = this.getTestNamefromList(this.selctedTestID);
          this.viewTestObj.ipVersion = 'v4';
          let persistEnabled = config['persist'];
          if(typeof persistEnabled === 'string') {
            persistEnabled = (persistEnabled === 'true') ? true : false;
          }
          this.viewTestObj.restartOnBoot = persistEnabled;
          if (config['prefix-length']) {
            //ipv6 load config
            this.viewTestObj.ipAddressV6 = this.viewTestObj.ipAddress;
            this.viewTestObj.gatewayV6 = this.viewTestObj.gateway;
            this.viewTestObj.prefixV6 = config['prefix-length'];
            this.viewTestObj.ipVersion = 'v6';
          } else {
            this.viewTestObj.ipAddressV6 = this.defaultConfig.ipAddressV6;
            this.viewTestObj.gatewayV6 = this.defaultConfig.gatewayV6;
            this.viewTestObj.prefixV6 = this.defaultConfig.prefixV6;
          }

          this.viewTestObj.maxSessions =
            config['max-connections'] || this.defaultConfig.maxSessions;
          this.viewTestObj.maxFlows = config['max-flows'] || this.defaultConfig.maxFlows;
          this.viewTestObj.udpport = config['reflector-udp-port'] || this.defaultConfig.udpport;
          try {
            const twampObj = JSON.parse(config.twamp);
            this.viewTestObj.port = twampObj['ietf-twamp:twamp']['twamp-server']['server-tcp-port'];
            this.viewTestObj.maxSessions =
              config['max-connections'] ||
              twampObj['ietf-twamp:twamp']['twamp-server']['max-connections'] ||
              this.defaultConfig.maxSessions;
            this.viewTestObj.maxFlows =
              config['max-flows'] ||
              twampObj['ietf-twamp:twamp']['twamp-server']['max-flows'] ||
              this.defaultConfig.maxFlows;
          } catch (err) {
            //eslint-disable-next-line
            console.log('twamp-reflect-ctrl:init: JSON parse failed: ' + JSON.stringify(err));
          }
          this.viewTestObj.port = this.viewTestObj.port || this.defaultConfig.port;
          this.isLoading = false;
          this.formObj = { ...this.viewTestObj };
        }
      });

    // startup test status polling
    this.isLoading = false;
    this.timeoutPromise[this.selctedTestID] = this.timeout.set(
      'reflector-' + this.selctedTestID,
      () => {
        this.startPollingTestStatus(this.selctedTestID);
      },
      100
    );
  }

  startPollingTestStatus(testId: string): void {
    if (this.timeoutPromise[testId]) {
      this.timeout.cancel(this.timeoutPromise[testId]);
    }
    this.testListService
      .getTestStatus(testId)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        response => {
          this.handleTestStatusResponse(response);
        },
        response => {
          this.stopTestStatusPoll(testId);
          this.setErrorMessage(response.message);
        }
      );
  }

  getTestNamefromList(testID: string): string {
    const objIndex = this.activeTestlist.findIndex(obj => obj.id == testID);
    return this.activeTestlist[objIndex].instanceName;
  }

  getActiveTestlist(): any {
    const runningTest = this.activity.tests;
    let activeTests = [];
    if (this.activity) {
      if (this.activity.status === 'running') {
        if (runningTest) {
          if (runningTest['twamp-reflector']) {
            activeTests = runningTest['twamp-reflector'];
            activeTests.map(test => {
              test.type = 'twamp-reflector';
              test.status = 'running';
            });
          }
          if (runningTest['twamp-light-reflector']) {
            const lightReflector = runningTest['twamp-light-reflector'];
            if (lightReflector) {
              lightReflector.map(test => {
                test.type = 'twamp-light-reflector';
                test.status = 'running';
              });
            }
            if (activeTests) {
              activeTests = activeTests.concat(lightReflector);
            } else {
              activeTests = lightReflector;
            }
          }
        }
      }
    }
    if (activeTests.length > 0) {
      activeTests.sort((a, b) => {
        return b.id - a.id;
      });
      this.activeTabID = activeTests[0].id;
      this.selctedTestID = activeTests[0].id;
      this.selectedTestInfo = activeTests[0];
    }
    return activeTests;
  }

  // eslint-disable-next-line
  stopTestStatusPoll(scheduleId): void {
    if (this.timeoutPromise[scheduleId]) {
      this.timeout.cancel(this.timeoutPromise[scheduleId]);
    }
  }

  //eslint-disable-next-line
  generateInstanceName(testnameSufix): string {
    const sufixval = parseInt(testnameSufix + 1);
    let testName = 'Reflector-' + sufixval;
    const isExisting = this.activeTestlist.some(el => {
      return el.instanceName == testName;
    });
    if (isExisting) {
      testName = this.generateInstanceName(sufixval);
    }
    return testName;
  }

  getInactiveTestConfigs(testName: string): void {
    this.isLoading = true;
    if (testName === 'newTest') {
      const listCnt = this.activeTestlist.length || 0;
      this.newTestObj.instanceName = this.generateInstanceName(listCnt);
      this.formObj = { ...this.newTestObj };
    } else {
      const config = this.savedTestConfigs.filter(obj => {
        return obj.instanceName === testName;
      })[0];
      if (config) {
        this.viewTestObj = {};
        this.viewTestObj.ipVersion = config.ipVersion || 'v4';
        this.viewTestObj.instanceName = config.instanceName;
        this.viewTestObj.ipAddress = config.ipAddress;
        this.viewTestObj.subnet = config.subnet;
        this.viewTestObj.gateway = config.gateway;
        if (this.agentModel.indexOf('vPMA') != -1) {
          this.viewTestObj.sVlanId = config.sVlanId;
          this.viewTestObj.sVLanPriority = config.vLanPriority || '0';
          this.viewTestObj.cVlan = config.cVlan;
          this.viewTestObj.cVlanPriority = config.cVlanPriority || '0';
          this.viewTestObj.vlanId = '';
          let configVlan = 'untagged';
          if (this.viewTestObj.sVlanId && this.viewTestObj.cVlan) {
            configVlan = 'q_in_q';
          } else if (this.viewTestObj.sVlanId) {
            configVlan = 'tagged';
          }
          this.viewTestObj.vlanNumber = configVlan;
        } else {
          this.viewTestObj.vlanId = config.vlanId;
          this.viewTestObj.vLanPriority = config.vLanPriority || '0';
        }
        this.viewTestObj.enableVlan = !!this.viewTestObj.vlanId;
        this.viewTestObj.etherType = config['tpid'] || this.defaultConfig.etherType;
        this.viewTestObj.port = config.port || this.defaultConfig.port;
        this.viewTestObj.ipAddressV6 = config.ipAddressV6 || this.defaultConfig.ipAddressV6;
        this.viewTestObj.prefixV6 = config.prefixV6 || this.defaultConfig.prefixV6;
        this.viewTestObj.gatewayV6 = config.gatewayV6 || this.defaultConfig.gatewayV6;
        this.selectedTestInfo = config;
        this.viewTestObj.maxSessions = config.maxSessions || this.defaultConfig.maxSessions;
        this.viewTestObj.maxFlows = config.maxFlows || this.defaultConfig.maxFlows;
        this.viewTestObj.udpport = config.udpport || this.defaultConfig.udpport;
        if (config.reflectorMode) {
          this.viewTestObj.reflectorMode = config.reflectorMode;
          if (config.reflectorMode == 'light') {
            this.viewTestObj.liteModeSelect = true;
          } else {
            this.viewTestObj.liteModeSelect = false;
          }
        }
        this.formObj = { ...this.viewTestObj };
      }
    }
    this.isLoading = false;
    this.isUniqueConfig();
    this.validateInstanceName();
  }

  getRunningTestConfigs(): any {
    let testList = this.activeTestlist.filter(obj => {
      return obj.status === 'running';
    });
    let initiatorTests = [];
    if (this.activity.tests['twamp-initiator']) {
      initiatorTests = this.activity.tests['twamp-initiator'];
      if (initiatorTests) {
        initiatorTests.map(test => {
          test.type = 'twamp-initiator';
        });
        if (testList) {
          testList = testList.concat(initiatorTests);
        } else {
          testList = initiatorTests;
        }
      }
    }
    this.allActiveTestList = testList;
    const testListCount = testList.length;
    for (let i = 0; i < testListCount; i++) {
      const testId = testList[i].id;
      this.controllerApiService
        .getTestConfig(testId, true)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(response => {
          let scheduleId = null;
          if (response.status === 'success') {
            scheduleId = response.data.id;
            const testType = this.getTestType(scheduleId);
            if (testType === 'twamp-reflector' || testType === 'twamp-light-reflector') {
              this.updateInstanceName(scheduleId, response);
            }
            const config = this.lmap.getTestOptions(
              testType,
              [
                'client-ip',
                'source-ip',
                'sender-ip',
                'subnet',
                'gateway',
                'reflector-udp-port',
                'max-connections',
                'max-flows',
                'twamp',
                'vlan-id',
                'inner-vlan-id'
              ],
              response.data.config
            );
            if (config) {
              const isExisting = this.testConfigs.some(el => {
                return el.id === scheduleId;
              });
              if (!isExisting) {
                config.testType = testType;
                config.id = scheduleId;
                if (testType === 'twamp-initiator' && config.twamp) {
                  const clientIp = JSON.parse(config.twamp);
                  config['source-ip'] =
                    clientIp['ietf-twamp:twamp']['twamp-client']['twamp-client-ctrl-connection'][0][
                      'client-ip'
                    ];
                }
                this.testConfigs.push(config);
              }
            }
          }
        });
    }
  }

  validateInstanceName(): void {
    // validate the Instance Name is
    this.testNameisValid = true;
    if (this.isNewTestConfig && this.activeTestlist.length > 0) {
      let found = false;
      if (this.activeTabID) {
        found = this.activeTestlist.some(
          el =>
            el.instanceName.toLowerCase() === this.formObj.instanceName.toLowerCase() &&
            el.id !== this.activeTabID
        );
      } else {
        found = this.activeTestlist.some(
          el => el.instanceName.toLowerCase() === this.formObj.instanceName.toLowerCase()
        );
      }
      if (found) {
        this.testNameisValid = false;
      } else {
        this.testNameisValid = true;
      }
    }
  }

  reflectorVersionValid(): boolean {
    // Check the version of reflector, lite mode only supported on version >= 2.0
    if (this.data.getVersion()?.value && !(this.data.getVersion().value.indexOf('1.0') === 0)) {
      return true;
    } else {
      return false;
    }
  }

  checkModeType(): void {
    if (this.formObj.reflectorMode == 'full') {
      this.formObj.reflectorMode = 'light';
    } else {
      this.formObj.reflectorMode = 'full';
    }
  }

  isUniqueConfig(): void {
    if (this.isNewTestConfig) {
      if (this.testConfigs && this.testConfigs.length > 0) {
        const currentConfig = [];
        currentConfig['ipAddress'] =
          this.formObj.ipVersion === 'v4' ? this.formObj.ipAddress : this.formObj.ipAddressV6;
        let vlanNumber = this.formObj.vlanNumber;
        if (this.agentModel.indexOf('vPMA') != -1) {
          if (vlanNumber !== 'untagged') {
            currentConfig['vlanId'] = this.formObj.sVlanId;
            if (vlanNumber === 'q_in_q') {
              currentConfig['cVlan'] = this.formObj.cVlan;
            }
          }
        } else {
          vlanNumber = 'QTConfig';
          currentConfig['vlanId'] = this.formObj.vlanId;
        }
        const isExistingConfig = this.testConfigs.find(
          el => el['source-ip'] === currentConfig['ipAddress']
        );
        if (isExistingConfig) {
          if (vlanNumber === 'untagged') {
            if (isExistingConfig['source-ip'] === currentConfig['ipAddress']) {
              this.isnotUniqueIPConfig = true;
            } else {
              this.isnotUniqueIPConfig = false;
            }
          } else if (vlanNumber === 'tagged' || vlanNumber === 'QTConfig') {
            if (
              isExistingConfig['source-ip'] === currentConfig['ipAddress'] &&
              isExistingConfig['vlan-id'] === currentConfig['vlanId']
            ) {
              this.isnotUniqueConfig = true;
              this.isnotUniqueIPConfig = true;
            } else {
              this.isnotUniqueConfig = false;
              this.isnotUniqueIPConfig = false;
            }
          } else if (vlanNumber === 'q_in_q') {
            if (
              isExistingConfig['source-ip'] === currentConfig['ipAddress'] &&
              isExistingConfig['vlan-id'] === currentConfig['vlanId'] &&
              isExistingConfig['inner-vlan-id'] === currentConfig['cVlan']
            ) {
              this.isnotUniqueConfig = true;
              this.isnotUniqueIPConfig = true;
            } else {
              this.isnotUniqueConfig = false;
              this.isnotUniqueIPConfig = false;
            }
          }
        } else {
          this.isnotUniqueIPConfig = false;
          this.isnotUniqueConfig = false;
        }
      }
    }
  }

  //eslint-disable-next-line
  updateInstanceName(testID, response) {
    let testName = null;
    if (response.status === 'success') {
      if (response.data.config.test && response.data.config.test['test-list-data']) {
        testName = response.data.config.test['test-list-data'].instanceName;
        if (testID && testName) {
          const objIndex = this.activeTestlist.findIndex(obj => obj.id == testID);
          this.activeTestlist[objIndex].instanceName = testName;
          // remove any entry in the list that matched the name but not the testID -- old entry
          this.activeTestlist = this.activeTestlist.filter(
            tst => tst.id === testID || tst.instanceName !== testName
          );
        }
      } else {
        if (testID) {
          const objIndex = this.activeTestlist.findIndex(obj => obj.id == testID);
          const testObj = this.activeTestlist[objIndex];
          if (testObj && !testObj.instanceName) {
            const listCnt = this.activeTestlist.length - 1 || 0;
            testName = this.generateInstanceName(listCnt);
            this.activeTestlist[objIndex].instanceName = testName;
          }
        }
      }
    }
  }

  //eslint-disable-next-line
  onChangeVersion(ipVersion): void {
    this.selectedIpVersion = ipVersion;
  }

  //eslint-disable-next-line
  handleTestStatusResponse(response: any): void {
    const stopStates = ['finished', 'cancelled', 'timeout', 'lost', 'aborted', '45', '13'];
    if (stopStates.indexOf(response.status) >= 0) {
      // this reflector is done, end the poll let the user know
      if (response.id) {
        this.stopTestStatusPoll(response.id);
      }

      if (response.status === 'finished') {
        this.displayStopStatus({ status: 'success' });
      } else {
        if (response.status === 'aborted') {
          this.saveTestConfigs(response.id);
        }
        // make 'UI Comm looking' error
        this.displayStopStatus({ status: 'error', data: { message: response.message } });
      }
      this.deviceService.getReflectorDevices();
    } else {
      const statusResp = response;
      let msg = null;
      if (typeof statusResp.message === 'string') {
        // see if it is a json object
        try {
          msg = JSON.parse(statusResp.message);
        } catch (err) {
          //console.log('TWAMP Reflector status message is not JSON: ' + err.message);
        }
      }

      if (
        this.holdingPattern === true &&
        ((statusResp.message && statusResp.message === 'test running') ||
          (msg && (msg['TWAMP Reflector test'] || msg['testPort'] === 'Configured')))
      ) {
        // not really looking for anything special, once any JSON data is returned the test should be up
        // Failure to start due to source IP already in use will result in no JSON data
        this.holdingPattern = false;
        this.deviceService.getReflectorDevices();
        this.setSuccessMessage('Reflector is running');
      }
      // Current Session Count
      if (msg && msg['Number of Connections']) {
        this.activeSessions = this.addCommas(msg['Number of Connections']);
      } else {
        this.activeSessions = '---';
      }
      // Current Flow Count
      if (msg && msg['Number of Sessions']) {
        this.activeFlows = this.addCommas(msg['Number of Sessions']);
      } else {
        this.activeFlows = '---';
      }
      // Reflected Packets
      if (msg && msg['Reflected Packets']) {
        this.packetsReflected = this.addCommas(msg['Reflected Packets']);
      } else {
        this.packetsReflected = '---';
      }
      this.timeoutPromise[response.id] = this.timeout.set(
        'reflector-' + response.id,
        () => {
          this.startPollingTestStatus(response.id);
        },
        this.pollingInterval
      );
    }
  }

  showStopDialog(): void {
    const param = {
      id: 'twamp_reflector-stop',
      alternateMsg: `Are you sure, you want to stop reflector <b>${this.formObj.instanceName}</b> ?`,
      callBackService: this,
      callBackFuntion: () => {
        this.stopEndpoint();
        this.raiseConfirm = true;
      },
      callBackFnParams: {
        self: this
      }
    };
    this.dialogService.showDialog('confirm', 'body', param);
  }

  cancelstop(): void {
    this.raiseConfirm = false;
  }

  showRemoveDialog(): void {
    const param = {
      id: 'twamp_reflector-remove',
      alternateMsg: `Are you sure, you want to remove reflector <b>${this.formObj.instanceName}</b>?`,
      callBackService: this,
      callBackFuntion: () => {
        this.removeTest();
        this.removeConfirm = true;
      },
      callBackFnParams: {
        self: this
      }
    };
    this.dialogService.showDialog('confirm', 'body', param);
  }

  cancelRemove(): void {
    this.removeConfirm = false;
  }

  cancelMaxTest(): void {
    this.isExceedMaxTest = false;
  }

  stopEndpoint(): void {
    this.raiseConfirm = false;
    this.actionMsg = 'stopping...';
    this.errorMsg = null;

    // have a fake 1 second delay just to show spinner dialog since
    // if it stops quickly the Loading Test dialog will come before the Stopping Test dialog
    //
    if (this.selctedTestID) {
      this.testListService
        .stopSingleTest$(this.selctedTestID)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(
          response => {
            this.displayStopStatus(response);
          },
          response => {
            this.setErrorMessage('Could not stop reflector: ' + response.message);
          }
        );
    } else {
      this.setErrorMessage('Cannot stop. I have no schedule ID for ' + this.deviceName);
    }
  }

  //eslint-disable-next-line
  addCommas(num): any {
    let mynum = num;
    if (typeof mynum !== 'string') {
      mynum = num.toString();
    }
    return mynum.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  reflectorTypeValid(): boolean {
    if (
      this.agentModel === 'vPMA' ||
      this.agentModel === 'vPMA-L' ||
      this.agentModel === 'QT600-10'
    ) {
      return true;
    } else {
      return false;
    }
  }

  // Only called when the test successfully stopped or the test itself
  // told us it is not running anymore.
  // Failure to get a valid status response (response.status from UIComm != success) should not call this.
  //eslint-disable-next-line
  displayStopStatus(response: any): void {
    if (response.status === 'success') {
      if (this.selctedTestID) {
        this.stopTestStatusPoll(this.selctedTestID);
      }
      this.setSuccessMessage('Reflector is no longer running');
      this.deviceService.getReflectorDevices();
    } else {
      this.setErrorMessage(response.data.message);
    }
    this.saveTestConfigs(this.selctedTestID); // Save the test configs
    this.activity.status = 'idle';
    this.activity.message = 'ready';
  }

  saveTestConfigs(testID: number): void {
    if (testID) {
      // Update test status
      this.isNewTestConfig = true;
      this.selctedTestID = null;
      const objIndex = this.activeTestlist.findIndex(obj => obj.id == testID);
      this.activeTestlist[objIndex].status = 'idle';
      this.testConfigs = this.testConfigs.filter(tst => tst.id !== testID);
      // save our data
      const stopedTestConfigs = this.formObj;
      stopedTestConfigs.id = testID;
      stopedTestConfigs.status = 'idle';

      stopedTestConfigs.portID = this.deviceData.phyId;
      this.savedTestConfigs.push(stopedTestConfigs);
      const data = {
        name: this.schedName,
        config: this.savedTestConfigs
      };
      this.controllerApiService
        .saveEndpointData(data)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(
          response => {
            if (response.status === 'error') {
              this.notificationService.onFail(
                'Endpoint data for ' + this.schedName + ' was not saved: ' + response.message
              );
              // , $rootScope.$broadcast("displayToast", {type: 'error', msg: 'Endpoint data for ' + this.schedName + ' was not saved: ' + response.message, delay: 10000 });
            }
          },
          () => {}
        );
    }
  }

  isExceedsMaxlimit(): boolean {
    const reflectorRunningTest = this.activeTestlist.filter(obj => {
      return obj.status === 'running';
    });
    const maxTestCount = Number(this.maxConcurrentTestCount);
    let otherTests = 0;
    if (this.activity.tests) {
      Object.keys(this.activity.tests).forEach(key => {
        if (key !== 'twamp-reflector' && key !== 'twamp-light-reflector') {
          otherTests = otherTests + this.activity.tests[key].length;
        }
      });
    }
    const testCount = reflectorRunningTest.length + otherTests;
    if (Number(maxTestCount) <= Number(testCount)) {
      if (this.agentModel === 'QT600-10') {
        if (
          reflectorRunningTest &&
          reflectorRunningTest[0] &&
          reflectorRunningTest[0].status === 'running'
        ) {
          this.isExceedMaxTest = true;
        } else {
          this.isExceedMaxTest = false;
        }
      } else {
        this.isExceedMaxTest = true;
      }
    }
    return this.isExceedMaxTest;
  }

  setErrorMessage(message: string): void {
    if (message) {
      message = message.replace('$$20110$$', ''); //remove error code holder
    }
    this.actionMsg = null;
    this.errorIcon = 'warning';
    this.errorMsg = message;
    setTimeout(() => {
      this.errorMsg = null;
    }, 3000);
  }

  setSuccessMessage(message: string): void {
    this.actionMsg = null;
    this.errorIcon = 'check_circle';
    this.errorMsg = message;
    setTimeout(() => {
      this.errorMsg = null;
    }, 3000);
  }

  okClicked(): void {
    this.actionMsg = null;
    this.errorMsg = null;
  }

  getSavedTestConfigs(): void {
    // get our saved config from UI DB. The best we got if any.
    this.controllerApiService
      .findEndpointData(this.schedName)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        response => {
          const data = response.data?.uiData;
          if (data && data.config) {
            if (data.config.length > 0) {
              this.savedTestConfigs = data.config;
            }
            if (this.deviceData.phyId) {
              this.savedTestConfigs = this.savedTestConfigs.filter(
                tst => tst.instanceName && tst.portID === this.deviceData.phyId
              );
            }
            if (this.savedTestConfigs.length > 0) {
              const savedTestConfigs = this.savedTestConfigs.map(el => {
                const reflector =
                  el.reflectorMode === 'full' ? 'twamp-reflector' : 'twamp-light-reflector';
                const arrobje = {
                  id: el.id,
                  instanceName: el.instanceName,
                  type: reflector,
                  status: el.status
                };
                return arrobje;
              });
              if (this.activeTestlist.length > 0) {
                this.activeTestlist = this.activeTestlist.concat(savedTestConfigs);
              } else {
                this.activeTestlist = savedTestConfigs;
                if (this.selctedTestID === null) {
                  const listCnt = this.activeTestlist.length || 0;
                  this.formObj.instanceName = this.generateInstanceName(listCnt);
                }
              }
            }
          }
        },
        () => {}
      );
  }

  removeTest(): void {
    this.removeConfirm = false;
    const testID = this.activeTabID;
    const objIndex = this.activeTestlist.findIndex(obj => obj.id == testID);
    if (objIndex !== -1) {
      this.activeTestlist = this.activeTestlist.filter(tst => tst.id !== testID);
      this.savedTestConfigs = this.savedTestConfigs.filter(tst => {
        return tst.id !== testID;
      });
      const data = {
        name: this.schedName,
        config: this.savedTestConfigs
      };
      this.controllerApiService
        .saveEndpointData(data)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(
          response => {
            if (response.status === 'error') {
              this.notificationService.onFail(
                'Endpoint data for ' + this.schedName + ' was not saved: ' + response.message
              );
              // , $rootScope.$broadcast("displayToast", {type: 'error', msg: 'Endpoint data for ' + this.schedName + ' was not saved: ' + response.message, delay: 10000 });
            }
          },
          () => {}
        );

      const testListCount = this.activeTestlist.length;
      if (testListCount <= 0) {
        this.createNewInstance();
      } else {
        let nextTest = null;
        if (objIndex < testListCount) {
          nextTest = this.activeTestlist[objIndex];
        } else {
          nextTest = this.activeTestlist[objIndex - 1];
        }
        this.selectedInstance(nextTest, false);
      }
    }
  }

  startEndpoint(): void {
    const islimitExceed = this.isExceedsMaxlimit();
    if (!islimitExceed) {
      if (!this.isnotUniqueConfig && !this.isnotUniqueIPConfig) {
        this.actionMsg = 'submitting test...';
        this.errorMsg = null;

        const configuration = this.getTestConfig();

        if (configuration !== null) {
          this.testListService
            .saveControllerTest$(configuration)
            .pipe(takeUntil(this.unsubscribe))
            .subscribe(
              response => {
                this.testStarted(response);
              },
              errorRes => {
                this.testStarted(errorRes.error);
              }
            );
        }
      }
    } else {
      this.dialogService.showInfo(
        'information',
        'body',
        'No more reflectors can be created for this device.',
        'Error - Exceeds Max test limit'
      );
    }
  }

  //Callback function after test started
  //eslint-disable-next-line
  testStarted(response): void {
    if (response.status === 'success') {
      this.isNewTestConfig = false;
      this.holdingPattern = true; // need to wait for more info before saying test is really started
      this.actionMsg = 'test accepted, now starting...';
      this.activity.status = 'running';
      this.activity.message = 'TWAMP Reflector';
      let testType = null;
      if (this.formObj.reflectorMode == 'full') {
        testType = 'twamp-reflector';
        this.activity.tests['twamp-reflector'] = {
          id: response.data.id,
          runId: response.data['run-id']
        };
      } else {
        testType = 'twamp-light-reflector';
        this.activity.tests['twamp-light-reflector'] = {
          id: response.data.id,
          runId: response.data['run-id']
        };
      }
      const arrobje = {
        id: response.data.id,
        runId: 1,
        status: 'running',
        type: testType,
        instanceName: this.formObj.instanceName
      };
      this.newTestObj = { ...this.defaultConfig }; // reset default config
      this.addNewTestListing(arrobje);
      this.selctedTestID = response.data.id;
      // startup test status polling
      this.timeoutPromise[response.data.id] = this.timeout.set(
        'reflector-' + response.data.id,
        () => {
          this.startPollingTestStatus(response.data.id);
        },
        this.pollingInterval
      );
    } else {
      if(response && response?.data?.id) {
        this.stopTestStatusPoll(response.data.id);
      }
      this.setErrorMessage('Could not start reflector: ' + response?.data?.message);
    }
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  addNewTestListing(obj) {
    if (this.activeTabID) {
      const objIndex = this.activeTestlist.findIndex(tst => tst.id === this.activeTabID);
      if (objIndex !== -1) {
        this.activeTestlist[objIndex].id = obj.id;
        this.activeTestlist[objIndex].instanceName = obj.instanceName;
        this.activeTestlist[objIndex].status = obj.status;
        this.activeTestlist[objIndex].type = obj.type;
        this.savedTestConfigs = this.savedTestConfigs.filter(tst => {
          return tst.id !== this.activeTabID;
        });
        const data = {
          name: this.schedName,
          config: this.savedTestConfigs
        };
        this.controllerApiService
          .saveEndpointData(data)
          .pipe(takeUntil(this.unsubscribe))
          .subscribe(
            response => {
              if (response.status === 'error') {
                this.notificationService.onFail(
                  'Endpoint data for ' + this.schedName + ' was not saved: ' + response.message
                );
              }
            },
            () => {}
          );
      }
    } else {
      if (this.activeTestlist.length > 0) {
        this.activeTestlist.unshift(obj);
      } else {
        this.activeTestlist.push(obj);
      }
    }
    this.activeTabID = obj.id;
    this.isNewTestConfig = false;
    this.selectedTestInfo = obj;
    this.selctedTestID = obj.id;
    this.reflectorModeName = obj.type;
  }

  getTestConfig(): any {
    const serverConfig = this.serverConfigService.getCollectorConfig();

    const collectorURL = this.lmap.buildCollectorPostUrl(serverConfig, this.agentModel);
    if (collectorURL == null) {
      this.setErrorMessage(
        'Collector information is not available. Verify browser has connectivity to server and verify server configuration.'
      );
      return null;
    }

    const validConfig = true;
    if (validConfig !== true) {
      this.setErrorMessage('Please correct any data above that have errors.');
      return null;
    }

    const twampServer = {};
    twampServer['server-admin-state'] = true; //purposely hard-coded - this is all we support
    twampServer['server-tcp-port'] = this.formObj.port;
    twampServer['dscp'] = 0; //purposely hard-coded - this is all we support
    twampServer['mode'] = 'bits.unauthenticated'; //purposely hard-coded - this is all we support
    const twampTest = {};
    twampTest['twamp-server'] = twampServer;

    const allTestParams = {};
    allTestParams['ietf-twamp:twamp'] = twampTest;

    // ------ Wrap the test-specific configuration in LMAP

    // create the test schedule
    // create task name and testschedulename based on modes
    let testScheduleName = '';
    let testTaskName = '';
    if (this.formObj.reflectorMode == 'full') {
      testScheduleName = this.deviceData.phyId
        ? this.schedName + '-' + this.deviceData.phyId
        : this.schedName;
      testTaskName = 'twamp-reflector';
    } else {
      testScheduleName =
        'TWAMP-LIGHT-REFLECTOR-' + this.deviceData.phyId
          ? this.deviceName + '-' + this.deviceData.phyId
          : this.deviceName;
      testTaskName = 'twamp-light-reflector';
    }

    testScheduleName = testScheduleName + '-' + this.formObj.instanceName;
    const testActionName = testScheduleName + '-action';

    const testEventName = 'immediate';

    const isIpv6 = 'v6' === this.formObj.ipVersion;
    const actionOption2 = {
      id: '',
      value: ''
    };
    if (isIpv6) {
      actionOption2.id = 'prefix-length';
      actionOption2.value = this.formObj.prefixV6;
    } else {
      actionOption2.id = 'subnet';
      actionOption2.value = this.formObj.subnet;
    }
    const actionOption3 = {
      id: '',
      value: ''
    };
    actionOption3.id = 'gateway';
    actionOption3.value = isIpv6 ? this.formObj.gatewayV6 : this.formObj.gateway;

    const actionOption4 = {
      id: '',
      value: ''
    };
    actionOption4.id = 'source-ip';
    actionOption4.value = isIpv6 ? this.formObj.ipAddressV6 : this.formObj.ipAddress;

    const persist = this.formObj.restartOnBoot;
    const actionOptionReboot = {
      id: '',
      value: ''
    };
    actionOptionReboot.id = 'persist';
    actionOptionReboot.value = this.formObj.restartOnBoot ? 'true' : 'false';

    const optionArray = [];
    optionArray.push(actionOption4);
    optionArray.push(actionOption2);
    optionArray.push(actionOption3);
    optionArray.push(actionOptionReboot);

    if (this.formObj.reflectorMode == 'full') {
      const actionOption = {
        id: '',
        value: ''
      };
      actionOption.id = 'twamp';
      actionOption.value = JSON.stringify(allTestParams);

      const actionOption5 = {
        id: '',
        value: ''
      };
      actionOption5.id = 'max-connections';
      actionOption5.value = this.formObj.maxSessions;

      const actionOption6 = {
        id: '',
        value: ''
      };
      actionOption6.id = 'max-flows';
      actionOption6.value = this.formObj.maxFlows;

      optionArray.push(actionOption6);
      optionArray.push(actionOption5);
      optionArray.push(actionOption);
    } else {
      const actionOption7 = {
        id: '',
        value: ''
      };
      actionOption7.id = 'reflector-udp-port';
      actionOption7.value = this.formObj.udpport;
      optionArray.push(actionOption7);
    }

    // if our agent has multiple ports
    if (this.deviceData.phyId) {
      const actionOptionPhy = {
        id: '',
        value: ''
      };
      actionOptionPhy.id = 'phy-id';
      actionOptionPhy.value = this.deviceData.phyId;
      optionArray.push(actionOptionPhy);
    }

    if (this.agentModel.indexOf('vPMA') == -1 && this.formObj.enableVlan && this.formObj.vlanId) {
      //VLAN and Priority
      const actionOptionVlanId = {
        id: '',
        value: ''
      };
      actionOptionVlanId.id = 'vlan-id';
      actionOptionVlanId.value = this.formObj.vlanId;
      optionArray.push(actionOptionVlanId);

      const actionOptionVlanPriority = {
        id: '',
        value: ''
      };
      actionOptionVlanPriority.id = 'vlan-priority';
      actionOptionVlanPriority.value = '0'; // default value
      optionArray.push(actionOptionVlanPriority);
    }

    if (
      this.agentModel.indexOf('vPMA') != -1 &&
      this.formObj.vlanNumber !== 'untagged' &&
      this.formObj.sVlanId
    ) {
      // Q-in-Q
      const actionOptionVlanId = {
        id: '',
        value: ''
      };
      actionOptionVlanId.id = 'vlan-id';
      actionOptionVlanId.value = this.formObj.sVlanId;
      optionArray.push(actionOptionVlanId);

      const actionOptionVlanPriority = {
        id: '',
        value: ''
      };
      actionOptionVlanPriority.id = 'vlan-priority';
      actionOptionVlanPriority.value = '0'; // default value
      optionArray.push(actionOptionVlanPriority);

      if (this.formObj.vlanNumber === 'q_in_q') {
        const actionOptionCvlanId = {
          id: '',
          value: ''
        };
        actionOptionCvlanId.id = 'inner-vlan-id';
        actionOptionCvlanId.value = this.formObj.cVlan;
        optionArray.push(actionOptionCvlanId);

        const actionOptionCvlanIdPriority = {
          id: '',
          value: ''
        };
        actionOptionCvlanIdPriority.id = 'inner-vlan-priority';
        actionOptionCvlanIdPriority.value = '0'; // default value
        optionArray.push(actionOptionCvlanIdPriority);

        const actionOptionTpid = {
          id: '',
          value: ''
        };
        actionOptionTpid.id = 'tpid';
        actionOptionTpid.value = this.formObj.etherType;
        optionArray.push(actionOptionTpid);
      }
    }

    const action = this.lmap.createAction(testActionName, testTaskName, optionArray);
    const actionArray = [];
    actionArray.push(action);
    // while report schedule references could be created here they will be added automatically to this schedule via addResultScheduleAndEvent()

    const testSchedule = this.lmap.createSchedule(testScheduleName, testEventName, actionArray);

    // build the LMAP configuration (test schedule + result schedules + all events other than those predefined by MA such as immediate)
    const lmapified = this.lmap.addSchedule(testSchedule);

    // results are not posted but define one result schedule for now so test controller can
    // identify this as a test schedule.
    //lmapified = lmap.addResultScheduleAndEvent(lmapified, testScheduleName, "periodic", "rt", collectorURL, 60);

    const tpInfo = {
      name: this.deviceName,
      nameId: this.deviceName,
      type: 'inventory'
    };
    const controllerConfig = this.testAssembleService.buildPrimaryTestConfig(
      tpInfo,
      testTaskName,
      lmapified
    );
    controllerConfig.test['test-list-data'] = {};
    controllerConfig.test['test-list-data'].instanceName = this.formObj.instanceName;
    controllerConfig.test['ipv6'] = this.selectedIpVersion == 'v6' ? 'yes' : 'no';
    return controllerConfig;
  }

  // handle reflector light port range check
  // port range 1-65535, except for 5060
  //
  handleReflectorLightPortRange(): void {
    if (
      this.formObj.udpport >= 1 &&
      this.formObj.udpport <= 65535 &&
      this.formObj.udpport != 5060
    ) {
      this.form.controls.udpport.setErrors(null);
    } else {
      this.form.controls.udpport.setErrors({ regex: 'wrong' });
    }
  }

  createNewInstance(): void {
    const islimitExceed = this.isExceedsMaxlimit();
    if (!islimitExceed) {
      if (this.selctedTestID) {
        this.stopTestStatusPoll(this.selctedTestID);
      }
      this.activeTabID = null;
      this.isNewTestConfig = true;
      this.selctedTestID = null;
      this.selectedTestInfo = null;
      this.getInactiveTestConfigs('newTest');
    } else {
      this.dialogService.showInfo(
        'information',
        'body',
        'No more reflectors can be created for this device.',
        'Error - Exceeds Max test limit'
      );
    }
  }

  //eslint-disable-next-line
  selectedInstance(instance, isNewtestStarted) {
    if (this.activeTabID === null && !isNewtestStarted) {
      this.newTestObj = { ...this.formObj };
    }
    if (this.selctedTestID && this.selctedTestID !== instance.id) {
      this.stopTestStatusPoll(this.selctedTestID);
    }
    this.activeTabID = instance.id;
    if (instance.status === 'running') {
      this.isNewTestConfig = false;
      this.selectedTestInfo = instance;
      if (this.selctedTestID !== instance.id) {
        this.selctedTestID = instance.id;
        this.reflectorModeName = instance.type;
        this.getActiveTestConfigs(instance.id);
      }
    } else {
      this.isNewTestConfig = true;
      this.selctedTestID = null;
      this.getInactiveTestConfigs(instance.instanceName);
    }
  }

  //eslint-disable-next-line
  getTestType(testID): any {
    const objIndex = this.allActiveTestList.findIndex(obj => obj.id == testID);
    return this.allActiveTestList[objIndex].type;
  }

  isEditable(): boolean {
    let isEditable = true;
    if (!this.isNewTestConfig && (this.actionMsg || this.selctedTestID)) {
      isEditable = false;
    }
    return isEditable;
  }
  isDiableBtn(): boolean {
    let butnDisable = false;
    if (
      this.isNewTestConfig &&
      (!this.testNameisValid || this.isnotUniqueConfig || this.isnotUniqueIPConfig)
    ) {
      butnDisable = true;
    }
    return butnDisable;
  }

  //   onChangeVersion (ipVersion) {
  //     this.selectedIpVersion = ipVersion;
  //     const epDialog = angular.element(document.getElementsByClassName('ep-dialog')[0]);
  //     if (ipVersion === 'v6') {
  //         angular.element(document.getElementsByClassName('main-contain')[0]).addClass('unset-width');
  //         //epDialog.addClass('extend');
  //     } else {
  //         epDialog.removeClass('extend');
  //     }
  // }
}
